import { formatBrDateHourUTC } from "../../../infra/helpers/date";

export const colunas = [
  {
    title: 'Data',
    dataIndex: 'DataHora',
    key: 'DataHora',
    render(data: any) {
      return formatBrDateHourUTC(data);
    },
    width: 170,
  },
  {
    title: 'Tabela',
    dataIndex: 'Tabela',
    key: 'Tabela'
  },
  {
    title: 'Ação',
    dataIndex: 'Acao',
    key: 'Acao',
  },
  {
    title: 'Chave',
    dataIndex: 'Chave',
    key: 'Chave'
  },
  {
    title: 'Usuário',
    dataIndex: 'UsuarioLogin',
    key: 'UsuarioLogin'
  },
]
